<div class="container">
  <app-loading [showLoading]="isLoading"></app-loading>
  <h1 class="header">
    <div class="title">カイクラの連携</div>
    <button
      type="button"
      mat-icon-button
      class="close-button"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <form class="main" (submit)="onSubmit($event)">
    <div class="form">
      <div class="field">
        <label class="label" for="kaikura-server-name">
          サーバ名
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          <div class="value">
            <input
              id="kaikura-server-name"
              class="input"
              [class.error]="
                serverName.touched &&
                (serverName.hasError('required') ||
                  serverName.hasError('pattern'))
              "
              [placeholder]="isEditMode ? '未入力なら変更しません' : 'n'"
              [formControl]="serverName"
            />
          </div>
          @if (serverName.touched && serverName.hasError('required')) {
            <div class="input-error">サーバ名は必須です</div>
          }
          @if (serverName.touched && serverName.hasError('pattern')) {
            <div class="input-error">
              サーバ名は半角英数字とハイフンで入力してください
            </div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="kaikura-id">
          環境 ID
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          <div class="value">
            <input
              id="kaikura-id"
              class="input"
              [class.error]="
                id.touched &&
                (id.hasError('required') || id.hasError('pattern'))
              "
              [placeholder]="
                isEditMode ? '未入力なら変更しません' : 'X999-0000-000-00'
              "
              [formControl]="id"
            />
          </div>
          @if (id.touched && id.hasError('required')) {
            <div class="input-error">環境 ID は必須です</div>
          }
          @if (id.touched && id.hasError('pattern')) {
            <div class="input-error">
              環境 ID は半角英大文字・数字・ハイフンで入力してください
            </div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="kaikura-secret">
          秘密の文字列
          @if (!isEditMode) {
            <span> *</span>
          }
          :
        </label>
        <div class="input-with-error">
          @if (isEditMode) {
            <div class="input-help">※未入力なら現在の値を維持します</div>
          }
          <div class="value secret-value">
            <input
              id="kaikura-secret"
              class="input"
              [type]="isSecretVisible ? 'text' : 'password'"
              autocomplete="new-password"
              [class.error]="secret.touched && secret.hasError('required')"
              [placeholder]="
                isEditMode ? '未入力なら変更しません' : '秘密の文字列'
              "
              [formControl]="secret"
            />
            <button
              type="button"
              class="secret-visibility-button"
              [attr.aria-label]="
                isSecretVisible ? '秘密の文字列を隠す' : '秘密の文字列を表示'
              "
              (click)="isSecretVisible = !isSecretVisible"
            >
              <mat-icon>
                {{ isSecretVisible ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </button>
          </div>
          @if (secret.touched && secret.hasError('required')) {
            <div class="input-error">秘密の文字列は必須です</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="kaikura-tag">連携対象タグ * :</label>
        <div class="input-with-error">
          <div class="tag-input-row">
            <input
              id="kaikura-tag"
              class="input"
              [class.error]="isSubmitted && !hasTagAllowlist()"
              placeholder="商談"
              [formControl]="tagInput"
              (keydown.enter)="$event.preventDefault()"
            />
            <button
              type="button"
              rectangle
              variant="secondary"
              [disabled]="isAddTagDisabled()"
              (click)="addTag()"
            >
              追加
            </button>
          </div>
          @if (tagAllowlist.length > 0) {
            <div class="tag-list">
              @for (tag of tagAllowlist; track tag) {
                <span class="tag-chip">
                  {{ tag }}
                  <button
                    type="button"
                    class="tag-remove"
                    [attr.aria-label]="tag + 'を削除'"
                    (click)="removeTag(tag)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </span>
              }
            </div>
          }
          @if (isSubmitted && !hasTagAllowlist()) {
            <div class="input-error">
              連携対象タグを 1 つ以上追加してください
            </div>
          }
          @if (isTagDuplicated()) {
            <div class="input-error">同じタグは追加できません</div>
          }
        </div>
      </div>

      <div class="field">
        <label class="label" for="kaikura-skill-map">連携 SkillMap * :</label>
        <div class="input-with-error">
          <div class="value">
            <app-select
              id="kaikura-skill-map"
              [options]="skillMapOptions"
              [selectedOption]="selectedSkillMap"
              [showError]="isSubmitted && !isSkillMapSelected()"
              (selectedOptionChange)="changeSkillMap($event)"
            ></app-select>
          </div>
          @if (isSubmitted && !isSkillMapSelected()) {
            <div class="input-error">連携 SkillMap は必須です</div>
          }
        </div>
      </div>

      @if (errorMessage) {
        <div class="error-message">
          {{ errorMessage }}
        </div>
      }
    </div>

    <div class="footer">
      <button type="button" rectangle variant="secondary" (click)="close()">
        キャンセル
      </button>
      <button
        type="submit"
        rectangle
        variant="primary"
        [disabled]="isSaveDisabled()"
      >
        保存
      </button>
    </div>
  </form>
</div>
